const size = {
  sm: "640px",
  md: "800px",
  lg: "1200px",
  xl: "1600px",
}

export const media = {
  sm: `(min-width: ${size.sm})`,
  md: `(min-width: ${size.md})`,
  lg: `(min-width: ${size.lg})`,
  xl: `(min-width: ${size.xl})`,
}
